import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ep-bt-field-agent-controls',
  template: `
    <p>
      ep-bt-field-agent-controls works!
    </p>
  `,
  styles: []
})
export class EpBtFieldAgentControlsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
